import type { Hco, ParentHco } from '@/core/graphql/generated/types';

import { type AffiliationRowValuesIn } from '../_schemas/AffiliationsSection.validation';

import { getPrimaryAddressLocation } from './getPrimaryAddressLocation';

export const mapParentHcosIn = (
	src: readonly ParentHco[] | null | undefined
): AffiliationRowValuesIn[] => {
	if (!src?.length) return [];

	return src.map(rel => {
		const targetHco = (
			rel.parentHco?.__typename === 'HCO' ? rel.parentHco : {}
		) as Hco;

		return {
			vid_V: rel.vid_V,
			jobTitle_V: rel.jobTitle_V ?? '',
			typeOfRelationship_VId: rel.relationshipType?.name ?? '',
			classOfWork_V: rel.classOfWork_V ?? '',
			isPrimaryRelationship_V: rel.isPrimaryRelationship_V ?? false,
			hcoNameIntl_V: targetHco.hcoNameIntl_V ?? '',

			parentHcoVid: targetHco.vid_V ?? '',
			hcoNameCda_V: targetHco.hcoNameCda_V ?? '',
			hcoType: targetHco.hcoType?.name ?? '',
			hcoStatus: targetHco.statusCda_V ?? '',
			location: getPrimaryAddressLocation(targetHco),
			addresses: targetHco.addresses ?? []
		};
	});
};
